import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="bg-white text-black py-8 md:py-12 font-sans">
      <div className="w-full flex flex-col items-center text-center space-y-4 md:space-y-6 px-4">
        {/* Logo ve Slogan */}
        <div className="space-y-2 md:space-y-3">
          <h3 className="text-2xl md:text-4xl font-bold text-black tracking-wide" style={{ fontFamily: 'Georgia, "Times New Roman", Times, serif' }}>
            Kostüm Akademi
          </h3>
          <p className="text-base md:text-lg text-gray-700 font-medium">
            En kaliteli kostümler, en uygun fiyatlarla!
          </p>
        </div>

        {/* Hakkımızda ve Yardım - Her zaman yan yana */}
        <div className="flex flex-row justify-center items-start gap-2 md:gap-4 w-full max-w-lg">
          <div className="text-center flex-1">
            <h4 className="text-lg md:text-xl font-bold mb-3 md:mb-4 text-black">Hakkımızda</h4>
            <ul className="space-y-1 md:space-y-2">
              <li>
                <a
                  href="/about"
                  className="text-gray-700 hover:text-orange-500 transition-colors duration-200 font-medium text-sm md:text-base"
                >
                  Biz Kimiz?
                </a>
              </li>
              <li>
              <a
                  href="/faq"
                  className="text-gray-700 hover:text-orange-500 transition-colors duration-200 font-medium text-sm md:text-base"
                >
                  Sıkça Sorulan Sorular
                </a>
              </li>
            </ul>
          </div>

          <div className="text-center flex-1">
            <h4 className="text-lg md:text-xl font-bold mb-3 md:mb-4 text-black">Yardım</h4>
            <ul className="space-y-1 md:space-y-2">
              <li>
                <a
                  href="/terms"
                  className="text-gray-700 hover:text-orange-500 transition-colors duration-200 font-medium text-sm md:text-base"
                >
                  Kullanıcı Sözleşmesi
                </a>
              </li>
              <li>
                <a
                  href="/privacy"
                  className="text-gray-700 hover:text-orange-500 transition-colors duration-200 font-medium text-sm md:text-base"
                >
                  Gizlilik Politikası
                </a>
              </li>
              <li>
           
              </li>
            </ul>
          </div>
        </div>

        {/* Sosyal Medya */}
        <div className="text-center">
         
          <p className="text-gray-700 font-medium text-sm md:text-base">
           Instagram: <span className="text-gray-700 font-semibold">@kostumakademi</span>
          </p>
        </div>

        {/* Copyright */}
        <div className="pt-3 md:pt-4 border-t border-gray-200 w-full max-w-md">
          <p className="text-xs md:text-sm text-gray-600 font-medium">
            © 2025 Kostüm Akademi 𓃠. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
